export function editPaymentPatcher(data) {
    return {
        __typename: 'EditPaymentData',
        payment: {
            __typename: 'EditPaymentPayment',
            ...data.payment,
        },
    };
}
